import { render } from "./Left.vue?vue&type=template&id=0785c095"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Left.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0785c095"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0785c095', __exports__)) {
    api.reload('0785c095', __exports__)
  }
  
  module.hot.accept("./Left.vue?vue&type=template&id=0785c095", () => {
    api.rerender('0785c095', render)
  })

}


export default __exports__